import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { confirm } from '@app/components';
import { IGlobalState } from '@app/models';
import { basicService } from '@app/services';

export function ExceptionComponent() {
    const exceptionMessage: any = useSelector((state: IGlobalState) => state.basic.unhandledException);

    const { translation } = useTypedTranslation();

    useEffect(() => {
        if (exceptionMessage.message !== undefined) {
            showExceptionDialog();
        }
    }, [exceptionMessage]);

    const generateBody = () => {
        return (
            <>
                <div>
                    {/********* main error message section *********/}
                    <div className='typo-title'>{translation(exceptionMessage.message.message) ?? exceptionMessage.message}</div>
                    {exceptionMessage.message.exceptionMessage !== undefined && exceptionMessage.message.exceptionMessage !== '' &&
                        <div className='typo-title'>
                            {exceptionMessage.message.exceptionMessage}
                        </div>
                    }
                    {exceptionMessage.message.details !== undefined && exceptionMessage.message.details.length > 0 &&
                        (
                            <ul className='details-list'>
                                {exceptionMessage.message.details.map((errorDetail: any) => (
                                    <li>{errorDetail.key}: <code>{errorDetail.value}</code></li>
                                ))
                                }
                            </ul>
                        )
                    }

                    {/********* stack trace error section *********/}
                    <div>
                        {exceptionMessage.innererror !== undefined && exceptionMessage.statusCode !== undefined &&
                            (
                                <div className='typo-body2'>
                                    <span>{translation('STATUS_CODE')}: </span>
                                    <span>{exceptionMessage.statusCode}</span>
                                </div>
                            )
                        }

                        {exceptionMessage.innererror !== undefined && exceptionMessage.innererror.message !== undefined &&
                            (
                                <div className='typo-body2 error-message'>
                                    <span>{exceptionMessage.innererror.message}</span>
                                </div>
                            )
                        }

                        {exceptionMessage.innererror !== undefined && exceptionMessage.innererror.stacktrace !== undefined &&
                            (
                                <>
                                    <h3>Stacktrace</h3>
                                    <div className='exception-trace'><pre>{exceptionMessage.innererror.stacktrace}</pre></div>
                                </>
                            )
                        }

                        <div className='typo-caption'>{exceptionMessage.moreInfo}</div>
                    </div>

                    {/********* not found error section *********/}
                    {exceptionMessage.statusCode !== undefined && exceptionMessage.statusCode === 404 &&
                        (
                            <>
                                <div className='left big-face'>:-(</div>
                                <div className='left'>
                                    <h3>{translation('NOT_FOUND_EXCEPTION_HEADER')}</h3>
                                    <p>{translation('REQUESTED_PAGE_NOT_FOUND')}</p>
                                    <p className='nav-404'>
                                        <a href='/'>{translation('GO_HOME')}</a>
                                    </p>
                                </div>
                            </>
                        )
                    }

                    {/********* request and correlation info *********/}
                    {exceptionMessage.correlationId !== '' &&
                        (
                            <>
                                <h4 className='more-info-header'>{translation('MORE_INFORMATION')}</h4>
                                <div><b>{translation('STATUS_CODE')}: </b> <code>{exceptionMessage.statusCode}</code></div>
                            <div><b>Url: </b> <code style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{exceptionMessage.url}</code></div>
                                <p><b>Correlation ID:</b> <span>{exceptionMessage.correlationId}</span></p>
                            </>
                        )
                    }
                </div>
            </>
        );
    };

    const showExceptionDialog = () => {
        confirm(generateBody(),
            translation('OK'),
            undefined,
            translation('APP_ERROR')).then(
                () => {
                    basicService.redirect('/apps');
                },
                () => {
                    // no cancel
                }
            );
    };

    return null;
}
